<template>
	 <div class="animated fadeIn">
    <b-row>
      <b-col sm="12" md="12">
        <b-card class="card-accent-info">
          <div slot="header">
            Dossier N° {{ id }}
          </div>
            <b-row>
              <b-col sm="12" md="4" v-for="(justificatif, key) in justificatifs" :key="key">
                <div class="card card-accent-info">
                  <div class="card-header">
                    <div>
                      {{ justificatif.lib_cd_piece }}
                    </div>
                  </div>
                  <div class="card-body">
                    <ul>
                      <li>Etablissement : {{ justificatif.rs_pm_site }}</li>
                      <li>Bénéficiaire : {{ justificatif.prenom }} {{ justificatif.nom }}</li>
                      <li>Status : Envoyé </li>
                    </ul>
                    <a href="#" v-if="justificatif.is_uploaded" @click.prevent="download(justificatif.id,justificatif.id_pp_dest_reglement,justificatif.rs_pm_site, justificatif.lib_cd_piece)">Visualiser</a>
                  </div>
                  <div class="card-footer">
                    <button class="btn btn-success btn-block">Valider</button>
                    <button class="btn btn-danger btn-block" @click.prevent="showSendMailForm">Réfuser</button>
                  </div>
                </div>
              </b-col>
            </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import {  getBaseUrl, getProvider, getIdToken, getAccessToken} from '@/utils/auth'

import {  downloadFile } from "@/utils/fileHelper";


export default {
    data() {
	    return {
        id: '',
        justificatifs: []
	    }
	},
	created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.id = this.$route.params.id
      this.get()
	},
	methods: {
	  get() {
        let self = this;
        this.$store.commit("IS_LOADING", true);
        let numDossier = this.$route.params.id
        this.$axios
          .get("/espaceBeneficiaire/justificatifs/dossier/" + numDossier)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.justificatifs = response.data.data
            // this.buildData(response.data.data)
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text:
              "Un probléme est survenu, merci de contacter l'administrateur",
            showConfirmButton: false,
            timer: 5000
          });
        });
	  },
    download(justificatifId, nsi, etablissement,libelle) {
          let self = this;
          let config = { 'justificatifId' : justificatifId,
                          'nsi' : nsi,
                          'etablissement' : etablissement
                        }
          this.$store.commit("IS_LOADING", true);
          this.$axios
            .post("/espaceBeneficiaire/justificatifs/getfileextension", config)
            .then(response => {
              let extension = response.data.extension;
              this.$axios
              .post("/espaceBeneficiaire/justificatifs/telechargement", config , {responseType: 'arraybuffer'}).then(response => {
                this.$store.commit("IS_LOADING", false);
                downloadFile(response, libelle, extension);
              })
              .catch(function(error) {
                  self.$store.commit("IS_LOADING", false);
                  let errorText = "Un probléme est survenue, merci de contacter l'administrateur"
                  if (error.response && error.response.status === 404 && self !== undefined) {
                    errorText = "La piéce justificatif demandée n'existe pas"
                  }
                  self.$swal({
                  position: "top",
                  type:"error",
                  title:"Attention !!",
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                });
              });
            })
            .catch(function(error) {
                self.$store.commit("IS_LOADING", false);
                let errorText = "Un probléme est survenue, merci de contacter l'administrateur"
                if (error.response && error.response.status === 404 && self !== undefined) {
                  errorText = "La piéce justificatif demandée n'existe pas"
                }
                self.$swal({
                position: "top",
                type:"error",
                title:"Attention !!",
                text:errorText,
                showConfirmButton: false,
                timer: 5000
              });
            });
        },
    showSendMailForm() {
      let self = this
      this.$swal.fire({
        title: 'Envoyer un mél',
        input: 'textarea',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Envoyer',
        cancelButtonText: 'Annuler',
        showLoaderOnConfirm: true,
        preConfirm: (email) => {
          return fetch(`//api.github.com/users/${email}`)
            .then(response => {
              if (!response.ok) {
                throw new Error(response.statusText)
              }
              return response.json()
            })
            .catch(error => {
              this.$swal.showValidationMessage(
                `Request failed: ${error}`
              )
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if (result.value) {
          self.$swal.fire({
            title: `${result.value.login}'s avatar`,
            imageUrl: result.value.avatar_url
          })
        }
      })
    }
	}
}
</script>